import { ridSegment } from '@krp/client-runtime'

/**
 * Адреса реестра ресурсов Platform (`ResourcesController`, RP-A2). Литерал
 * `/api/` законен только в файлах `api/urls.ts` (eslint).
 */
export const PLATFORM_RESOURCES_URLS = {
  list: '/api/platform/v1/resources',
  /** Установленные виды ресурсов с правами и модулями из манифестов (ADR-22): форма «Добавить источник», права, вкладки. */
  connectors: '/api/platform/v1/connectors',
  one: (resourceId: string) => `/api/platform/v1/resources/${ridSegment(resourceId)}`,
  /** Проверка связи через Platform (`registry.write` + rid): POST, ответ `ResourceProbeResult`. */
  probe: (resourceId: string) => `/api/platform/v1/resources/${ridSegment(resourceId)}/probe`,
  /**
   * Мои ресурсы с правом (AU1b): `?capability=` обязателен, `?kind=` — по
   * желанию. Реестрового права не требует — это источник выбора для кассира.
   */
  mine: '/api/platform/v1/me/resources',
} as const
